import getProfileApi from '@/api/get/user-management/get-profile';
import OutletWrapper from '@/components/animations/animated-routes/animated-outlet';
import Header from '@/components/header/header-component';
import Loader from '@/components/loader/loader-component';
import SideNavigation from '@/components/side-navigation/side-navigation-component';
import { useQuery } from '@/hooks/use-api';
import AuthRoutes from '@/routes/auth-routes';
import getValidAuthRoutes from '@/utils/auth-routes';
import { APP_CONTEXT } from '@/utils/context';
import { useContext, useEffect, useState } from 'react';
import Styled from './main-layout-style';

/**
 * Shop Layout component.
 * @returns {JSX.Element} The rendered Shop Layout component.
 */
const AppLayout = () => {
  const [open, setOpen] = useState(false);
  const {
    activeSideNav,
    activeChildSideNav,
    setCurrentUser,
    currentUser,
    setPermissions,
    setIsSuper,
    isSuper,
    permissions,
    setCurrentTheme,
    currentTheme,
    showSideNav,
  } = useContext(APP_CONTEXT);
  const routes = AuthRoutes;
  const sideNavRoutes = getValidAuthRoutes(
    routes.filter((route) => route.sidebar),
    permissions,
    isSuper,
    currentUser?.type === 'company'
      ? {
          company_user_type: currentUser?.company_type,
          is_dealer: currentUser?.is_dealer,
          is_supplier: currentUser?.is_supplier,
        }
      : undefined,
  );

  const { data: userDetails, loading } = useQuery(getProfileApi);

  useEffect(() => {
    const data = userDetails || {};
    if (
      data !== undefined &&
      currentUser !== data?.user &&
      !currentUser?.updated
    ) {
      setCurrentUser(data?.user);
      setIsSuper(data?.user?.is_superuser);
      setPermissions(data?.permissions);
      setCurrentTheme({
        ...currentTheme,
        COLOR_PRIMARY: data?.user?.primary_color ?? '#ED1C24',
        COLOR_SECONDARY: data?.user?.secondary_color ?? '#000000',
      });
    }
  }, [
    currentTheme,
    currentUser,
    setCurrentTheme,
    setCurrentUser,
    setIsSuper,
    setPermissions,
    userDetails,
  ]);

  if (loading) {
    return (
      <Styled.LoaderContainer>
        <Loader loading />
      </Styled.LoaderContainer>
    );
  }

  return (
    <Styled.Main>
      <Styled.Nav>
        <Header burgerMenu={open} burgerMenuToggle={setOpen} currency={false} />
      </Styled.Nav>
      <Styled.Body $showSideNav>
        <SideNavigation
          open={open}
          setOpen={setOpen}
          navlinks={sideNavRoutes}
          activeSideNav={activeSideNav}
          activeChildSideNav={activeChildSideNav}
        />
        <Styled.DivSideMenu open={open} $showSideNav={showSideNav}>
          <OutletWrapper slide={25} slideUp={0} keyType="segment" />
          {open && (
            <Styled.OverLay
              onClick={() => {
                setOpen(false);
              }}
            />
          )}
        </Styled.DivSideMenu>
      </Styled.Body>
    </Styled.Main>
  );
};

export default AppLayout;
